import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateInstalledProductByIdMutationVariables = Types.Exact<{
  set?: Types.InputMaybe<Types.Installed_Products_Set_Input>;
  id: Types.Scalars['uuid']['input'];
}>;


export type UpdateInstalledProductByIdMutation = { __typename?: 'mutation_root', update_installed_products_by_pk?: { __typename?: 'installed_products', id: any, product_id: any, property_id: any, installation_date: any, warranty_expiration_date?: any | null, warranty_status: string, product_serial?: string | null, location?: string | null, photo_link?: string | null, installed_product_attachments: Array<{ __typename?: 'installed_product_attachments', installed_product_id: any, id: any, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, name?: string | null, transcribed: boolean, type?: string | null, description?: string | null }>, product: { __typename?: 'products', id: any, name: string, description: string, sku?: string | null, make: string, model: string, retail_price?: any | null, product_notes?: string | null, photo_link?: string | null, product_category: { __typename?: 'product_categories', name: string, label: string }, product_attachments: Array<{ __typename?: 'product_attachments', id: any, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, name?: string | null, transcribed: boolean, type?: string | null, description?: string | null }> }, property?: { __typename?: 'properties', id: any, name: string } | null } | null };


export const UpdateInstalledProductByIdDocument = gql`
    mutation updateInstalledProductById($set: installed_products_set_input, $id: uuid!) {
  update_installed_products_by_pk(_set: $set, pk_columns: {id: $id}) {
    id
    product_id
    property_id
    installation_date
    warranty_expiration_date
    warranty_status
    product_serial
    location
    photo_link
    installed_product_attachments {
      installed_product_id
      id
      photo_link
      document_link
      video_link
      audio_link
      site_link
      transcription
      name
      transcribed
      type
      description
    }
    product {
      id
      name
      description
      sku
      product_category {
        name
        label
      }
      make
      model
      retail_price
      product_notes
      photo_link
      product_attachments {
        id
        photo_link
        document_link
        video_link
        audio_link
        site_link
        transcription
        name
        transcribed
        type
        description
      }
    }
    property {
      id
      name
    }
  }
}
    `;
export type UpdateInstalledProductByIdMutationFn = Apollo.MutationFunction<UpdateInstalledProductByIdMutation, UpdateInstalledProductByIdMutationVariables>;

/**
 * __useUpdateInstalledProductByIdMutation__
 *
 * To run a mutation, you first call `useUpdateInstalledProductByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInstalledProductByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInstalledProductByIdMutation, { data, loading, error }] = useUpdateInstalledProductByIdMutation({
 *   variables: {
 *      set: // value for 'set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateInstalledProductByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInstalledProductByIdMutation, UpdateInstalledProductByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInstalledProductByIdMutation, UpdateInstalledProductByIdMutationVariables>(UpdateInstalledProductByIdDocument, options);
      }
export type UpdateInstalledProductByIdMutationHookResult = ReturnType<typeof useUpdateInstalledProductByIdMutation>;
export type UpdateInstalledProductByIdMutationResult = Apollo.MutationResult<UpdateInstalledProductByIdMutation>;
export type UpdateInstalledProductByIdMutationOptions = Apollo.BaseMutationOptions<UpdateInstalledProductByIdMutation, UpdateInstalledProductByIdMutationVariables>;